/* eslint-disable max-len */

import { type BankDetailsDataFragment } from '../../../../api/fragments/BankDetailsData';
import { type UploadFileFormDataFragment } from '../../../../api/fragments/UploadFileFormData';
import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { type BankSettings } from '../../../../api/types';

export { default as CreateBankFrom } from './CreateBankFrom';
export { default as EditBankForm } from './EditBankForm';
export { default as FinanceProductType } from './FinanceProductType';
export { default as CreateBankDetailsForm } from './CreateBankDetailsForm';
export { default as EditBankDetailsForm } from './EditBankDetailsForm';
export { default as BankIntegration } from './BankIntegration';
export { default as EmailBankIntegration } from './EmailBankIntegration';
export { default as HlfBankIntegration } from './HlfBankIntegration';
export { default as UobBankIntegration } from './UobBankIntegration';
export { default as EnbdBankIntegration } from './EnbdBankIntegration';
export { default as useBankFormValidator } from './useBankFormValidator';
export { default as useBankAvailableFinanceProductTypesValidation } from './useBankAvailableFinanceProductTypesValidation';

export type BankFormValues = BankSettings & {
    logo?: File | UploadFileWithPreviewFormDataFragment;
    font?: File | UploadFileFormDataFragment;
};

export type BankAvailableFinanceProductTypesValues = {
    availableFinanceProductTypes: BankDetailsDataFragment['availableFinanceProductTypes'];
    showMarginOfFinance: boolean;
};
export type BankIntegrationValues = BankDetailsDataFragment['integration'];
export type { NewBankFormValues } from './CreateBankFrom';
